// src/pages/ChatRoomsPage.jsx
import React from 'react';
import { motion } from 'framer-motion';

const ChatRoomsPage = () => {
    
    const pageContent = {
        hidden: { opacity: 0, y: -20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };
    
    return (
        <div className="public-page-container">
            <h1 className="public-page-title">Neighborhood Chat Rooms</h1>
            <p className="public-page-subtitle">Find real-time conversations for your specific corner of the city.</p>
            
            <motion.div 
                className="page-content-block" 
                style={{ maxWidth: '600px' }}
                variants={pageContent}
                initial="hidden"
                animate="visible"
            >
                <h3 style={{ marginTop: '0' }}>Access is Localized</h3>
                <p>
                    To maintain the integrity and relevance of our discussions, access to specific chat rooms is restricted to verified users of that neighborhood.
                    Please log in or create an account and verify your address to join the conversation.
                </p>
                <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '30px' }}>
                    <a href="/login">
                        <motion.button 
                            className="auth-button auth-primary-button"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Log In
                        </motion.button>
                    </a>
                    <a href="/signup">
                        <motion.button 
                            className="auth-button auth-secondary-button"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Sign Up
                        </motion.button>
                    </a>
                </div>
            </motion.div>
        </div>
    );
};

export default ChatRoomsPage;